import React from "react";

import { UiTable } from "../../../types";

function isNumericDisplayCell(cell: string): boolean {
  const text = cell.trim();
  if (!text || text === "—") return false;
  return /^₹/.test(text) || /^[\d,.\s%+-]+$/.test(text) || /^\d/.test(text);
}

export const DataTable: React.FC<{ table: UiTable; emptyLabel: string }> = ({ table, emptyLabel }) => {
  if (table.headers.length === 0 || table.rows.length === 0) return <div className="eventos-empty">{emptyLabel}</div>;
  return (
    <div className="eventos-table-wrap">
      <table className="eventos-table">
        <thead>
          <tr>
            {table.headers.map((header, colIdx) => (
              <th
                key={header}
                className={
                  colIdx > 0 && /price|amount|revenue|cost|fee|profit|qty|quantity|sold/i.test(header)
                    ? "eventos-table__num"
                    : undefined
                }
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, idx) => (
            <tr key={`${row.join("-")}-${idx}`}>
              {row.map((cell, colIdx) => (
                <td
                  key={`${cell}-${idx}-${colIdx}`}
                  className={colIdx > 0 && isNumericDisplayCell(cell) ? "eventos-table__num" : undefined}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
